__turbopack_context__.v({
  "column": "no0NxW_column",
  "errorMessage": "no0NxW_errorMessage",
  "fieldContainer": "no0NxW_fieldContainer",
  "form": "no0NxW_form",
  "input": "no0NxW_input",
  "label": "no0NxW_label",
  "loadingText": "no0NxW_loadingText",
  "locationContainer": "no0NxW_locationContainer",
  "locationIcon": "no0NxW_locationIcon",
  "submitButton": "no0NxW_submitButton",
  "submitSection": "no0NxW_submitSection",
  "suggestionContent": "no0NxW_suggestionContent",
  "suggestionItem": "no0NxW_suggestionItem",
  "suggestionText": "no0NxW_suggestionText",
  "suggestionsContainer": "no0NxW_suggestionsContainer",
  "suggestionsList": "no0NxW_suggestionsList",
  "termsLink": "no0NxW_termsLink",
  "termsText": "no0NxW_termsText",
  "twoColumnLayout": "no0NxW_twoColumnLayout",
});
